module.exports = __webpack_public_path__ + "logo.png?d7d2a61db8932ab20f2ab0ca7f1e8b11";